import { createContext } from "react";

export const CalendarContext = createContext({});
